module.exports = __webpack_public_path__ + "static/img/11.bfb163f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/11.png
// module id = h//I
// module chunks = 0